import { Component, inject, } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ChargepointTracesComponent } from '../chargepoint-traces/chargepoint-traces.component';
import { Chargepoint } from '../../../api/chargepoints-api.service';
import { ChargepointConfigurationDialogComponent } from '../../chargepoint-configuration/chargepoint-configuration-dialog/chargepoint-configuration-dialog.component';

@Component({
  selector: 'app-chargepoint-traces-dialog',
  templateUrl: './chargepoint-traces-dialog.component.html',
  styleUrls: ['./chargepoint-traces-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ChargepointTracesComponent
  ]
})
export class ChargepointTracesDialogComponent {
  public chargepoint!: Chargepoint;

  dialogRef = inject(MatDialogRef<ChargepointConfigurationDialogComponent>);
  data = inject(MAT_DIALOG_DATA);

  constructor() {
    this.chargepoint = this.data.chargepoint;
  }

  public close() {
    this.dialogRef.close();
  }
}
